const privacyPolicyEn = {
  breadcrumbs: { home: 'Home', title: 'Privacy Policy' },
  hero: {
    title: 'Privacy Policy',
    subtitle: 'Protecting your personal data and privacy is our priority'
  },
  principles: [
    { title: 'Data Security', description: 'We store your personal information with top-level security' },
    { title: 'Transparency', description: 'We clearly state what we collect and why' },
    { title: 'User Control', description: 'You have full control over your information' },
    { title: 'Privacy Protection', description: 'We do not share without your permission' }
  ],
  dataTypes: [
    { category: 'Personal Information', items: ['Name', 'Phone Number', 'Email Address', 'Date of Birth'], purpose: 'Create and manage your account' },
    { category: 'Address Information', items: ['Home Address', 'Delivery Address', 'Upazila', 'District'], purpose: 'Delivery and local services' },
    { category: 'Payment Information', items: ['Mobile Banking No.', 'Bank Account', 'Transaction History'], purpose: 'Secure payment processing' },
    { category: 'Usage Information', items: ['App usage history', 'Searches', 'Wishlist'], purpose: 'Provide personalized experience' }
  ],
  usage: {
    title: 'How We Use Information',
    primaryTitle: 'Primary Uses',
    primary: ['Create and manage account', 'Process orders and delivery', 'Provide customer support', 'Process payments'],
    improveTitle: 'Improvement Uses',
    improve: ['Personalized recommendations', 'Service quality improvements', 'Security and fraud prevention', 'Market research and analytics']
  },
  rights: {
    title: 'Your Rights',
    items: [
      { right: 'Right to Access', description: 'Know what information we store about you' },
      { right: 'Right to Rectification', description: 'Correct incorrect or outdated information' },
      { right: 'Right to Erasure', description: 'Request deletion of your personal information' },
      { right: 'Right to Data Portability', description: 'Download a copy of your information' }
    ]
  },
  security: {
    title: 'Security Measures',
    intro: 'We implement the following measures to protect your information:',
    measures: ['SSL encryption', 'Regular security audits', 'Two-factor authentication', 'Data backup and recovery', 'Access control systems', 'Regular system updates']
  },
  cookies: {
    title: 'Cookies Policy',
    usageTitle: 'Use of Cookies',
    p1: 'We use cookies to improve your browsing experience and personalize our services. Cookies are small text files stored on your device.',
    p2: 'You can control cookies in your browser settings. Disabling cookies may cause some services to not function properly.'
  },
  sharing: {
    title: 'Sharing with Third Parties',
    intro: 'We may share information with third parties in the following cases:',
    authorizedTitle: 'Authorized Sharing',
    notDoTitle: 'What We Do Not Do',
    authorized: ['Delivery partners (for addresses)', 'Payment gateways (for transactions)', 'Legal requirements (by court order)'],
    notDo: ['Sell to advertisers', 'Use for marketing without consent', 'Share with unnecessary third parties']
  },
  retention: {
    title: 'Data Retention Policy',
    retentionTitle: 'Retention Period',
    retentionText: 'We retain your personal information as long as your account is active or as needed to provide services.',
    deleteTitle: 'Deletion',
    deleteText: 'After account closure, we delete your personal information within 30 days unless legally required otherwise.'
  },
  updates: {
    title: 'Policy Updates',
    alert: 'This privacy policy may be updated from time to time',
    notify: 'We will notify you via email or app notifications about changes. For significant changes, we will obtain your consent.',
    lastUpdatedPrefix: 'Last updated:',
    lastUpdatedDate: 'December 2023'
  },
  contact: {
    title: 'Privacy Contact',
    subtitle: 'Contact us if you have any questions about this policy or your personal data',
    button: 'Contact Us',
    email: 'privacy@grameenbazar.com'
  }
};

export default privacyPolicyEn;


